module.exports = __webpack_public_path__ + "img/ribbon.5c876538.svg";